import { createSlice } from '@reduxjs/toolkit';

type CommonDataReducerType = {
  headerData: {
    enableHeaderBackButton: boolean;
  };
  currLang?: { label: string; value: string };
  siteConstant?: Record<string, any>;
};

const initialState: CommonDataReducerType = {
  headerData: {
    enableHeaderBackButton: true,
  },
};

export const CommonDataSlice = createSlice({
  name: 'CommonReducer',
  initialState,
  reducers: {
    updateHeaderData: (state, action) => {
      const data = action?.payload?.data ?? {};
      state.headerData = data;
    },
    updateSiteLanguage: (state, action) => {
      const data = action?.payload?.data ?? {};
      state.currLang = data;
    },
    updateSiteConstant: (state, action) => {
      const data = action?.payload?.data ?? {};
      state.siteConstant = data;
    },
  },
});

export const { updateHeaderData, updateSiteConstant, updateSiteLanguage } = CommonDataSlice.actions;
export default CommonDataSlice.reducer;
